import axios from "axios";

//state
export var propuestaState = {
  propuestas: [],
  propuesta: {},
  status_propuesta: ""
};

//getters
export var propuestaGetters = {
  //funciones para optener informacion del state
  getPropuestas: state => state.propuestas
};

//actions
export var propuestaActions = {
  async getPropuestas({ commit }) {
    commit("propuesta_request");
    await this._vm.$http
      .get("/apache/rest_api/apache.proposal", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields: "['id', 'name', 'description']"
        }
      })
      .then(res => {
        var propuestas = res.data;
        commit("propuesta_success", propuestas);
        return res;
      })
      .catch(err => {
        commit("propuesta_error");
        return err;
      });
  },
  async newPropuesta({ commit, state }, propuesta) {
    commit("propuesta_request");
    var { namePropuesta, descriptionPropuesta } = propuesta;
    var formData = new FormData();
    var newPropuesta = `{'name':'${namePropuesta}','description': '${descriptionPropuesta}'}`;
    formData.append("data", newPropuesta);
    await this._vm.$http
      .post("/apache/rest_api/apache.proposal", formData, {
        headers: {
          "X-Odoo-dbfilter": "apachev1"
        }
      })
      .then(res => {
        if (res.status == 201) {
          propuesta.id = res.data.id;
          propuesta.name = propuesta.namePropuesta;
          propuesta.description = propuesta.descriptionPropuesta;
          var propuestas = state.propuestas;
          propuestas.push(propuesta);
          commit("propuesta_success", propuestas);
          return propuestas;
        } else {
          commit("propuesta_error");
        }
      })
      .catch(err => {
        commit("propuesta_error");
        return err;
      });
  },
  async editPropuesta({ commit, state }, propuesta) {
    commit("propuesta_request");
    var { id, namePropuesta, descriptionPropuesta } = propuesta;
    var formData = new FormData();
    var newPropuesta = `{'name':'${namePropuesta}','description': '${descriptionPropuesta}'}`;
    formData.append("data", newPropuesta);
    await this._vm.$http
      .put("/apache/rest_api/apache.proposal", formData, {
        headers: {
          "X-Odoo-dbfilter": "apachev1"
        },
        params: {
          ids: `[${id}]`
        }
      })
      .then(res => {
        if (res.status == 200) {
          var index;
          propuesta.id = id;
          propuesta.name = propuesta.namePropuesta;
          propuesta.description = propuesta.descriptionPropuesta;
          var propuestas = state.propuestas;
          for (var i = 0; i < propuestas.length; i++) {
            if (propuestas[i].id == id) {
              index = i;
              propuestas[i] = propuesta;
              break;
            }
          }
          propuestas.splice(index, 1);
          propuestas.splice(index, 0, propuesta);
          commit("propuesta_success", propuestas);
          return propuestas;
        } else {
          commit("propuesta_error");
        }
      })
      .catch(err => {
        commit("propuesta_error");
        return err;
      });
  },
  async deletePropuesta({ commit, state }, id) {
    commit("propuesta_request");
    await this._vm.$http
      .delete(`/apache/rest_api/apache.proposal/${id}`, {
        headers: {
          "X-Odoo-dbfilter": "apachev1"
        }
      })
      .then(res => {
        if (res.status == 200) {
          var index;
          var propuestas = state.propuestas;
          for (var i = 0; i < propuestas.length; i++) {
            if (propuestas[i].id == id) {
              index = i;
              break;
            }
          }
          propuestas.splice(index, 1);
          commit("propuesta_success", propuestas);

          return propuestas;
        } else {
          commit("propuesta_error");
        }
      })
      .catch(err => {
        commit("propuesta_error");
        return err;
      });
  },
  async deletePropuestaUtility({ commit, state }, id) {
    commit("propuesta_request");
    var index;
    var propuestas = state.propuestas;
    for (var i = 0; i < propuestas.length; i++) {
      if (propuestas[i].id == id) {
        index = i;
        break;
      }
    }
    propuestas.splice(index, 1);
    commit("propuesta_success", propuestas);

    return propuestas;
  }
};

//mutations

export var propuestaMutations = {
  propuesta_request(state) {
    state.status_line = "loading";
  },
  propuesta_success(state, payload) {
    state.status_line = "success";
    state.propuestas = payload;
  },
  propuesta_error(state) {
    state.status_line = "error";
  }
};
